import ZoneConfigModal from './ZoneConfigModal';
export default ZoneConfigModal;
